import { getCoverageLinesText } from '@common/utils';

import { Content } from 'pdfmake/interfaces';
import { PartialSubmission } from 'types';

export function replacePlaceholdersInContent(content: Content, submission?: PartialSubmission | null) {
  const replacements: Record<string, string> = {
    '{{insuredName}}': submission?.insuredName || '',
    '{{coverageLines}}': submission?.coverageLines ? getCoverageLinesText(submission.coverageLines) : '',
  };

  const replacePlaceholders = (text: string): string => {
    let result = text;
    Object.entries(replacements).forEach(([placeholder, value]) => {
      result = result.replace(new RegExp(placeholder, 'g'), value);
    });
    return result;
  };

  const processContent = (obj: Content): Content => {
    if (typeof obj === 'string') {
      return replacePlaceholders(obj);
    }

    if (Array.isArray(obj)) {
      return obj.map(processContent);
    }

    if (obj && typeof obj === 'object') {
      const processed: any = {};
      Object.entries(obj).forEach(([key, value]) => {
        if (key === 'text' && typeof value === 'string') {
          processed[key] = replacePlaceholders(value);
        } else {
          processed[key] = processContent(value);
        }
      });
      return processed;
    }

    return obj;
  };

  return processContent(content);
}
